import { render, staticRenderFns } from "./MonthStat.vue?vue&type=template&id=197d9aa9&"
import script from "./MonthStat.vue?vue&type=script&lang=js&"
export * from "./MonthStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports